<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.hamburger-button {
    display: flex;
    height: 100%;
    justify-content: center;
    cursor: pointer;

    .button-icon {
        width: 28px;
        height: 20px;
        overflow: hidden;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        margin: auto 4px auto 4px;
        transition: height 0.3s, transform 0.4s;
        z-index: 200;

        span {
            color: $black;
            height: 3px;
            border-radius: 1px;
            width: 100%;
            background: $primary;
            display: flex;
            transition: all 0.3s;
            transform-origin: left;
            align-self: flex-end;
        }

        &.active {
            height: 22px;
            span {
                &:nth-child(1) {
                    transform: translateX(2px) rotate(45deg);
                }
                &:nth-child(2) {
                    opacity: 0;
                }
                &:nth-child(3) {
                    transform: translateX(2px) rotate(-45deg);
                }
            }
        }
    }

    &:hover {
        .button-icon {
            &:not(.active) {
                span {
                    &:nth-child(1) {
                        transform: translateX(-4px);
                    }
                    &:nth-child(2) {
                        transform: translateX(4px);
                    }
                    &:nth-child(3) {
                        transform: translateX(-4px);
                    }
                }
            }

            &.active {
                transform: rotate(180deg);
            }
        }
    }

    .text {
        display: none;
        align-self: center;
        font-family: $headings-font-family;
        color: $white;
        font-size: $font-size-in-between;
        font-weight: $font-weight-bold;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+/Edge */
        user-select: none; /* Standard */

        @media screen and (min-width: $screen-md) {
            display: inline;
        }
    }

    @media screen and (min-width: $screen-md) {
        margin-right: 20px;
    }
}

/**
 * No transition when resizing browser window
 */
body.resizing {
    .button-icon {
        transition: none !important;
        span {
            transition: none !important;
        }
    }
}
</style>

<template>
    <div class="hamburger-button" @click="toggleMenu">
        <div class="button-icon" :class="{'active': isActive}">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    mounted() {
        var self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                if (self.$root.navigationIsVisble) {
                    self.toggleMenu();
                }
            }
        };
    },

    methods: {
        toggleMenu() {
            this.$root.navigationIsVisble = !this.$root.navigationIsVisble;
        }
    },

    computed: {
        isActive() {
            return this.$root.navigationIsVisble;
        }
    }
}
</script>